// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { quoteSummaryCardStyles } from "@awc/Overrides/Components/QuoteSummaryCard";
import { ellipsis } from "@awc/XDL/Utilities";
import { css } from "styled-components";

quoteSummaryCardStyles.shiptoCell = {
    css: css`
        max-width: 320px;
        min-width: 220px;
        white-space: normal;
        > ${TypographyStyle} {
            ${ellipsis(1)}
        }
    `,
};

quoteSummaryCardStyles.dataCells = {
    tight: true,
};
